import {ExpNav} from "./ExpNav";

export const Exp2 = () => {
    return (
        <div className="experience">
            <ExpNav/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 style={{margin:"50px",padding:"20px"}}>Software developer - Tata Consultancy Services - India</h1>

            <p style={{fontSize:"x-large",margin:"20px",padding:"20px"}}>Full time position : Jul 2019 - Oct 2020 </p>

            <p style={{fontSize:"x-large",margin:"20px",padding:"30px",textAlign:"left"}}>
                I worked on Software development, deployment and maintenance. I got experienced to cloud technologies and various IT maintenance tools. I have solid understanding on Infrastructure setup activities and issues persisting to it. I am certified as AWS Solution architect and Devops Engineer.
                My work had crucial tasks for setting up of new production environment to banking software along with making developments and maintenance. To summarize, I worked on full Stack Web development using Java backend and Angular, React as frontend in an AWS infrastructure.
                I have also consulted clients with various infrastructure architecture to accelerate their workload and reduce time.
            </p>

            <br/>



        </div>
    )
}